// extracted by mini-css-extract-plugin
export default {"container":"video_container__0wgDJ","video":"video_video__g3vTU"};